export default __webpack_public_path__ + "static/media/shards_of_eth.0e3a61d4.svg";